export class SaveType {
  static CREATE = 1;
  static UPDATE = 2;
  static DELETE = 3;
  static ROW_UPDATE = 4;
  static BULK_UPDATE = 5;
  static BULK_EDIT = 6;
  constructor(value) {
    this.value = value;
  }
  isCreate() {
    return this.value === SaveType.CREATE;
  }
  isUpdate() {
    return this.value === SaveType.UPDATE;
  }
  isDelete() {
    return this.value === SaveType.DELETE;
  }
  isRowUpdate() {
    return this.value === SaveType.ROW_UPDATE;
  }
  isBulkUpdate() {
    return this.value === SaveType.BULK_UPDATE;
  }
  isBulkEdit() {
    return this.value === SaveType.BULK_EDIT;
  }
  isBulkUpdateOrRowUpdate() {
    return this.isBulkUpdate() || this.isRowUpdate();
  }
  isUpdateOrDelete() {
    return this.isUpdate() || this.isDelete();
  }
  isCreateOrUpdate() {
    return this.isCreate() || this.isUpdate();
  }
  static factory(value) {
    return new SaveType(value);
  }
  static factoryFromNewFlg(isNew) {
    if (isNew) {
      return new SaveType(SaveType.CREATE);
    }
    return new SaveType(SaveType.UPDATE);
  }
  static factoryDelete() {
    return new SaveType(SaveType.DELETE);
  }
  static factoryUpdate() {
    return new SaveType(SaveType.UPDATE);
  }
  static factoryRowUpdate() {
    return new SaveType(SaveType.ROW_UPDATE);
  }
  static factoryBulkUpdate() {
    return new SaveType(SaveType.BULK_UPDATE);
  }
  static factoryBulkEdit() {
    return new SaveType(SaveType.BULK_EDIT);
  }
}
